import { configureStore } from '@reduxjs/toolkit'
import adminSliceReducer from '../Reducers/adminSlice'
import userSliceReducer from '../Reducers/userSlice'
import  memberSliceReducer from '../Reducers/memberSlice'
import acctknSliceReducer from '../Reducers/acctknSlice'

export default configureStore({
  reducer: {
    admin:adminSliceReducer,
    user:userSliceReducer,
    member: memberSliceReducer,
    accessToken:acctknSliceReducer
},
})